export function pushOrRemoveElement(array, element) {
    const newArray = [...array]; // Create a new array
  
    if (newArray.includes(element)) {
        // Element is present, so remove it
        const index = newArray.indexOf(element);
        newArray.splice(index, 1);
    } else {
        // Element is not present, so push it
        newArray.push(element);
    }
  
    return newArray;
}